import { render, staticRenderFns } from "./ContentPageCustom.vue?vue&type=template&id=b4fba182&"
import script from "./ContentPageCustom.vue?vue&type=script&lang=js&"
export * from "./ContentPageCustom.vue?vue&type=script&lang=js&"
import style0 from "./ContentPageCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports